<template>
    <el-color-picker :predefine="predefine" v-model="color"> </el-color-picker>
</template>

<script>
export default {
    props: {
        value: {},
        predefine: {},
    },
    data() {
        return {
            color: null,
        };
    },
    created() {
        this.color = this.value;
    },
    mounted() {
        //
    },
    watch: {
        value(val) {
            this.color = val;
        },
        color(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        //
    },
};
</script>

<style lang="scss"></style>
